// 編輯模式Enum
export enum EditModeEnum {
  add = 'add', // 新增
  edit = 'edit', // 編輯
  view = 'view', // 檢視
  none = 'none', // 無
}
